import React, { memo } from 'react';
import { View } from 'react-native';
import { useTheme } from '@redlink/assets/styles';

export const Divider = memo(
  ({ color, size = 1, horizontal = true, style, margin = 0 }) => {
    const { colors } = useTheme();
    color = color || colors.black3;
    return (
      <View
        style={[
          style,
          { backgroundColor: color },
          horizontal && { height: size, marginVertical: margin },
          !horizontal && { width: size, marginHorizontal: margin },
        ]}
      />
    );
  }
);
